<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-plus"></i></div>
      <div>
        Liste des inscrits
        <div class="page-title-subheading">Inscriptions enregistrées pour l'année en cours</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="row">
      <div class="col-lg-12">
          <div class="card">
            
              <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" routerLink="/admin/inscription-create">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle inscription
                            </button>
                        <button (click)="openMasse(addContent)" type="button" class="btn btn-outline-info btn-sm">
                            <i class="fa-solid fa-file-import me-1" aria-hidden="true"></i>Importer en masse
                        </button>
                    </div>
                    <div *ngIf="buttonsPermission">
                      <button *ngIf="selected_data && buttonsPermission.show" (click)="show()" type="button" class="btn btn-outline-primary btn-sm me-3">
                           <span>Consulter</span></button>
                      <!-- <button *ngIf="selected_data && buttonsPermission.edit" type="button"  class="btn btn-outline-warning btn-sm me-3">
                         Editer</button> -->
                      <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm me-3">
                           Supprimer</button>
                        <button *ngIf="selected_data && is_valid!=null && !is_valid" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm me-3">
                            Valider l'inscription</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Code ou nom de l'élève" [(ngModel)]="search_text">
                    </div>
                  </div>

                          <p>{{data!.length}} élément(s)</p>
                          <div class="table-responsive">
                          <table class="table" >
                              <thead class="">
                                  <tr>
                                      <th style="width: 10px;">#</th>
                                      <th>Code</th>
                                      <th>Elève</th>
                                      <th>Type</th>
                                      <th>Statut</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'inscriptions' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                      <td>
                                          <div class="form-check mb-2">
                                              <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                          
                                          </div>
                                      </td>
                                      <td>{{d.code}}</td>
                                      <td>{{d.student?.lastname}} {{d.student?.firstname}}</td>
                                      <td>
                                        <span *ngIf="d.is_new" class="badge bg-success">Nouvelle</span>
                                        <span *ngIf="!d.is_new" class="badge bg-info text-dark">Réinscription</span>

                                      </td>
                                      <td>
                                          <span *ngIf="d.is_valid" class="badge bg-success">Validé</span>
                                          <span *ngIf="!d.is_valid" class="badge bg-warning text-dark">Non validé</span>
  
                                      </td>
                                  </tr>
                              
                              </tbody>
                          </table>
                          </div>
                          <pagination-controls 
                          id="ngxP1"
                          (pageChange)="getPage($event)"
                        [maxSize]="9"
                        [directionLinks]="true"
                        [autoHide]="true"
                        [responsive]="true"
                        [previousLabel]="'Précédent'"
                        [nextLabel]="'Suivant'"
                        [screenReaderPaginationLabel]="'Pagination'"
                        [screenReaderPageLabel]="'page'"
                        [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                       </pagination-controls>
              </div>
</div><!-- end card -->
          </div>
          <!-- end col -->
      </div>
      <!-- end col -->

  <ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="storeMasse(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Importer en masse</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class="form-group">
                <label for="">Choisir la classe</label>
                <ng-select name="classroom_id" ngModel>
                    <ng-option *ngFor="let classroom of classrooms" [value]="classroom.id">{{classroom?.name}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Fichier à importer</label>
                <input type="file" class="form-control" ngModel (change)="upload($event)" >
            </div>

        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>